import gql from "graphql-tag";

export default gql`
  mutation UpdateRequest($id: ID!, $status: RequestStatus) {
    updateRequest(id: $id, status: $status) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/UpdateRequest.ts